jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('click', '.schema-faq-question', function() {

        var $question = $(this);

        $question.toggleClass('active');

        // The faq-block variant animates purely via CSS (see components.css),
        // driven by the .active class above. Only the plain Yoast FAQ block
        // needs the JS show/hide fallback.
        if (!$question.closest('.faq-block-item').length) {
            $question.next().toggle();
        }

    });

});